export default __webpack_public_path__ + "static/media/PF-1.ba6a9d32.jfif";